import block_icons from "../icons/section";
import color_palette_list from '../gb-helper/color_palette';
import React from 'react'

const { registerBlockType, registerBlocksStyle } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls,
    BlockControls,
    AlignmentToolbar,
    BlockAlignmentToolbar,
    RichText,
    MediaUpload, MediaUploadCheck, InnerBlocks } = wp.editor;
const { PanelBody, PanelRow,
    TextControl, SelectControl, RangeControl, Dashicon, ToggleControl, ColorPalette, ColorIndicator,
    Card, CardBody, Button, AlignmentMatrixControl, AnglePickerControl, ColorGradientControl, __experimentalGradientPicker, ColorPicker } = wp.components;
const ALLOWED_BLOCKS = ['core/paragraph'];



registerBlockType('blocksbakery/section', {
    title: __('Section', 'blocks-bakery'),
    description: __(
        'This block is an outer wrap section that allows you to add other blocks within it.',
        'blocks-bakery'
    ),

    // common, formatting, layout, widgets, embed
    category: 'blocks-bakery',
    icon: block_icons.section_icon,
    keywords: [
        __('Section', 'blocks-bakery'),
        __('Paragraph', 'blocks-bakery')
    ],
    supports: {
        html: false
    },
    attributes: {
        unique_class_id: {
            type:'string',
            default:null,
        },
        // Layout
        img_ID: {
            type: 'number'
        },
        img_URL: {
            type: 'string'
        },
        img_alt: {
            type: 'string',
            source: 'attribute',
            attribute: 'alt',
            selector: 'img'
        },
        width_content: {
            type: 'html',
        },
        inner_width: {
            type: 'number',
            default: 1440,
        },
        maininner_width: {
            type: 'number',
            default: 550,
        },
        heading_tag: {
            type: 'string',
            default: 'section'
        },
        location1: {
            type: "number",
            default: 40
        },
        location2: {
            type: "number",
            default: 70
        },


        // Spacing
        top_padding: {
            type: 'number',
            default: 20,
        },
        gradient_bg: {
            type: 'string',

        },
        gradient_type: {
            type: 'string',
            default: 'linear-gradient'
        },
        bottom_padding: {
            type: 'number',
            default: 20,
        },
        left_padding: {
            type: 'number',
            default: 20,
        },
        right_padding: {
            type: 'number',
            default: 20,
        },
        uniqueID: {
            type: "string"
        },
        top_margin: {
            type: 'number',
            default: 0,
        },
        bottom_margin: {
            type: 'number',
            default: 0,
        },
        left_margin: {
            type: 'number',
            default: 0,
        },
        right_margin: {
            type: 'number',
            default: 0,
        },



        // Background Setting
        background_setting: {
            type: 'string',
        },
        color_opacity: {
            type: 'number',
            default: 100,
        },
        bg_color: {
            type: 'string',
            default: 'white'
        },
        gradient_color_1: {
            type: 'string',
        },
        gradient_color_2: {
            type: 'string',
        },
        angle_picker: {
            type: 'number',
            default: 0
        },
        color_opacity: {
            type: 'number',
            default: 1
        },
        color_gradient_opacity: {
            type: 'number',
            default: 100
        },
        opacity_value: {
            type: 'string',
            default: 'FF'
        },
        // border
        select_border: {
            type: 'string',
            default: 'dotted'
        },
        border_radius: {
            type: 'number',
            default: 10
        },
        border_width: {
            type: 'number',
            default: 1,
        },
        border_color: {
            type: 'string',
        },
        shadow_color: {
            type: 'string',
        },
        hori_shadow: {
            type: 'number',
            default: 0
        },
        vertical_shadow: {
            type: 'number',
            default: 0
        },
        blur_shadow: {
            type: 'number',
            default: 0
        },
        spread_shadow: {
            type: 'number',
            default: 0
        },
        shadow_selector: {
            type: 'text',
            default: ''
        },
        select_gg: {
            type: 'string',
            default: 'none'
        },
        save_background: {
            type: 'string',
            default: "linear-gradient"
        },
        url_click1: {
            type: "string",
        },
        url_click2: {
            type: "string",
        },
        section_alignment: {
            type: "string",
            default: "center"
        },
        block_alignment: {
            type: 'string',
            default: 'center'
        }
    },

    getEditWrapperProps: ({ block_alignment }) => {
        if ('left' === block_alignment || 'right' === block_alignment || 'full' === block_alignment) {
            return { 'data-align': block_alignment };
        }
    },
    edit: (props) => {


        if(!props.attributes.unique_class_id){
            props.setAttributes({unique_class_id: makeUnqiueId()})
        }

        const select_img = (img) => {
            props.setAttributes({
                img_ID: img.id,
                img_URL: img.url,
                img_alt: img.alt
            })
        };
        const remove_img = () => {
            props.setAttributes({
                img_URL: null,
                img_ID: null,
                img_alt: null
            })
        };
        const shadow_box = () => {
            var x = document.getElementById("shadow");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        };
        const hexConverter = (val) => {
            val = Math.round(val * 100) / 100;
            var alpha = Math.round(val * 255);
            var hex = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
            props.setAttributes({ opacity_value: hex })
        }


        const background_setting = (vvval) => {
            var background_changer = [];
            var x = document.getElementById("bg1");
            var y = document.getElementById("bg2");
            var z = document.getElementById("bg3");
            var a = document.getElementsByClassName("gb-section-inner");

            if (vvval === 'color') {
                x.style.display = 'block'
                y.style.display = 'none'
                z.style.display = 'none'
                props.setAttributes({ bg_color: props.attributes.bg_color })
            }
            else if (vvval === 'gradient') {
                y.style.display = 'block'
                z.style.display = 'none'
                x.style.display = 'none'
                props.setAttributes({ gradient_bg: props.attributes.gradient_bg })
            }
            else if (vvval = 'image') {
                x.style.display = 'none'
                y.style.display = 'none'
                z.style.display = 'block'
            }
        };

        const Divtag = props.attributes.heading_tag;
        const boxShadowReset = () => {
            props.setAttributes({ shadow_color: "" })
            props.setAttributes({ hori_shadow: 0 })
            props.setAttributes({ vertical_shadow: 0 })
            props.setAttributes({ blur_shadow: 0 })
            props.setAttributes({ spread_shadow: 0 })
            props.setAttributes({ shadow_selector: "" })
        }
        return [
            <React.Fragment>
                <style dangerouslySetInnerHTML={{
                    __html: `
                    .gb-section${props.attributes.unique_class_id}{align:${props.attributes.block_alignment}} 
                    .gb-section${props.attributes.unique_class_id} .gb-section-wrapper .gb-section-inner{margin:auto; box-sizing:border-box; border-radius:${props.attributes.border_radius}px; box-shadow:${props.attributes.hori_shadow}px ${props.attributes.vertical_shadow}px ${props.attributes.blur_shadow}px ${props.attributes.spread_shadow}px ${props.attributes.shadow_color} ${props.attributes.shadow_selector}; margin-top:${props.attributes.top_margin}px;margin-bottom: ${props.attributes.bottom_margin}px; margin-left: ${props.attributes.left_margin}px; margin-right: ${props.attributes.right_margin}px; max-width: ${props.attributes.width_content}px; background-size:cover; background-position:center; background-image:url(${props.attributes.img_URL});position:relative; }
                    .gb-section${props.attributes.unique_class_id} .gb-section-wrapper .gb-section-inner .gb-section-inner-overlay{ border-style: ${props.attributes.select_border}; border-width: ${props.attributes.border_width}px; border-color: ${props.attributes.border_color}; padding-top: ${props.attributes.top_padding}px; padding-bottom: ${props.attributes.bottom_padding}px; padding-left: ${props.attributes.left_padding}px; padding-right: ${props.attributes.right_padding}px; border-radius: ${props.attributes.border_radius}px; background: ${props.attributes.gradient_bg}; background-color: ${props.attributes.bg_color + props.attributes.opacity_value}; overflow-wrap:break-word; }
                    .gb-section${props.attributes.unique_class_id} .gb-section-wrapper .gb-section-inner .gb-section-inner-overlay .gb-section-changetag{ max-width: ${props.attributes.maininner_width}px; margin: 'auto';}
                    `
                }}></style>
                <InspectorControls>
                    <PanelBody title={__('Layout', 'blocks-bakery')} initialOpen={true}>
                        <RangeControl
                            label={__('Box Width', 'blocks-bakery')}
                            min={0}
                            max={2000}
                            initialPosition={580}
                            value={props.attributes.width_content}
                            onChange={(new_val) => {
                                props.setAttributes({ width_content: new_val })
                                props.setAttributes({ maininner_width: new_val })
                            }} />
                        <RangeControl
                            label={__('Content width', 'blocks-bakery')}
                            min={0}
                            max={2000}
                            initialPosition={1140}
                            value={props.attributes.inner_width}
                            onChange={(new_val) => {
                                props.setAttributes({ inner_width: new_val })
                                props.setAttributes({ maininner_width: new_val })
                            }}
                            help="adjust your content according to your box width"
                        />
                        <hr />
                        <SelectControl
                            label={__('HTML Tag', 'blocks-bakery')}
                            value={props.attributes.heading_tag}
                            options={[
                                { value: 'div', label: 'Div' },
                                { value: 'header', label: 'Header' },
                                { value: 'footer', label: 'Footer' },
                                { value: 'main', label: 'Main' },
                                { value: 'article', label: 'Article' },
                                { value: 'section', label: 'Section' },
                                { value: 'aside', label: 'Aside' },
                                { value: 'nav', label: 'Nav' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ heading_tag: new_val })
                            }}
                        />
                    </PanelBody>
                    <PanelBody title={__('Spacing', 'blocks-bakery')} initialOpen={false}>
                        <PanelRow><label style={{ fontWeight: "bold" }}>{__('Padding', 'blocks-bakery')}</label></PanelRow>
                        <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.984h-14c-1.103 0-2 0.897-2 2v0.797h18v-0.797c0-1.103-0.897-2-2-2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    initialPosition={20}
                                    value={props.attributes.top_padding}
                                    step={0.1}
                                    onChange={(new_val) => {
                                        props.setAttributes({ top_padding: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                            }}
                                onClick={() => {
                                    props.setAttributes({ top_padding: 20 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.656 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M3 19.016h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.103 0.897 2 2 2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    value={props.attributes.bottom_padding}
                                    step={0.1}
                                    initialPosition={20}
                                    onChange={(new_val) => {
                                        props.setAttributes({ bottom_padding: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                            }}
                                onClick={() => {
                                    props.setAttributes({ bottom_padding: 20 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.656 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M0.984 2.999v14c0 1.103 0.896 2 2 2h0.797v-18h-0.797c-1.104 0-2 0.897-2 2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    value={props.attributes.left_padding}
                                    step={0.1}
                                    initialPosition={20}
                                    onChange={(new_val) => {
                                        props.setAttributes({ left_padding: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                            }}
                                onClick={() => {
                                    props.setAttributes({ left_padding: 20 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.656 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M19.015 16.999v-14c0-1.103-0.896-2-2-2h-0.797v18h0.797c1.104 0 2-0.896 2-2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    value={props.attributes.right_padding}
                                    step={0.1}
                                    initialPosition={20}
                                    onChange={(new_val) => {
                                        props.setAttributes({ right_padding: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                            }}
                                onClick={() => {
                                    props.setAttributes({ right_padding: 20 })
                                }}> Reset
                            </Button>
                        </div>

                        <hr />
                        <PanelRow><label style={{ fontWeight: "bold" }}>{__('Margin', 'blocks-bakery')}</label></PanelRow>
                        <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.984h-14c-1.103 0-2 0.897-2 2v0.797h18v-0.797c0-1.103-0.897-2-2-2z"></path></svg>}
                                    min={-2000}
                                    max={2000}
                                    initialPosition={0}
                                    value={props.attributes.top_margin}
                                    step={0.1}
                                    onChange={(new_val) => {
                                        props.setAttributes({ top_margin: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                            }}
                                onClick={() => {
                                    props.setAttributes({ top_margin: 0 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.656 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M3 19.016h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.103 0.897 2 2 2z"></path></svg>}
                                    min={-2000}
                                    max={2000}
                                    value={props.attributes.bottom_margin}
                                    step={0.1}
                                    initialPosition={0}
                                    onChange={(new_val) => {
                                        props.setAttributes({ bottom_margin: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                            }}
                                onClick={() => {
                                    props.setAttributes({ bottom_margin: 0 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.656 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M0.984 2.999v14c0 1.103 0.896 2 2 2h0.797v-18h-0.797c-1.104 0-2 0.897-2 2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    value={props.attributes.left_margin}
                                    step={0.1}
                                    initialPosition={0}
                                    onChange={(new_val) => {
                                        props.setAttributes({ left_margin: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                            }}
                                onClick={() => {
                                    props.setAttributes({ left_margin: 0 })
                                }}> Reset
                            </Button>
                        </div>

                        <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    beforeIcon={<svg width="20" height="20"><path fill="#999" d="M17 0.999c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17-0.001h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.656 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M19.015 16.999v-14c0-1.103-0.896-2-2-2h-0.797v18h0.797c1.104 0 2-0.896 2-2z"></path></svg>}
                                    min={0}
                                    max={2000}
                                    value={props.attributes.right_margin}
                                    step={0.1}
                                    initialPosition={0}
                                    onChange={(new_val) => {
                                        props.setAttributes({ right_margin: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                            }}
                                onClick={() => {
                                    props.setAttributes({ right_margin: 0 })
                                }}> Reset
                            </Button>
                        </div>
                    </PanelBody>
                    <PanelBody title={__('Background', 'blocks-bakery')} initialOpen={false}>
                        <SelectControl
                            label={__('Background Type', 'blocks-bakery')}
                            value={props.attributes.background_setting}
                            options={[
                                { value: 'none', label: 'None' },
                                { value: 'color', label: 'Color' },
                                { value: 'gradient', label: 'Gradient' },
                                { value: 'image', label: 'Image' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ background_setting: new_val })
                                background_setting(new_val)
                            }}
                        />
                        <div id='bg1' style={{ display: 'none' }}>
                            <p><span>{__('Background Color', 'blocks-bakery')}
                                <ColorIndicator style={{ backgroundColor: props.attributes.bg_color }} /></span></p>

                            <ColorPalette
                                colors={color_palette_list}
                                value={props.attributes.bg_color}
                                disableCustomColors={false}
                                onChange={(new_val) => {
                                    props.setAttributes({ bg_color: new_val })
                                }}
                            />
                            <p>Opacity</p>
                            <RangeControl
                                min={0}
                                max={1}
                                value={props.attributes.opacity_value}
                                step={0.01}
                                onChange={(new_val) => {
                                    props.setAttributes({ opacity_value: new_val })
                                    hexConverter(new_val)
                                }}
                            />

                        </div>
                        <div id='bg2' style={{ display: 'none' }}>
                            <__experimentalGradientPicker
                                value={props.attributes.gradient_bg}
                                onChange={(new_val) => {
                                    props.setAttributes({ gradient_bg: new_val })
                                }}
                            />
                        </div>
                        <hr />
                        <div id='bg3' style={{ display: 'none' }}>
                            {props.attributes.img_ID ? (
                                <div className="image-ctr">
                                    <img src={props.attributes.img_URL}
                                        alt={props.attributes.img_alt} />
                                    {props.isSelected ? (
                                        <Button className="btn-remove" onClick={remove_img}>
                                            <Dashicon icon='no' size='20' />
                                        </Button>
                                    ) : null}
                                </div>
                            ) : (
                                <MediaUploadCheck>
                                    <MediaUpload
                                        allowedType={['image']}
                                        value={props.attributes.img_ID}
                                        onSelect={select_img}
                                        render={({ open }) => (
                                            <Button className={"button button-large"} onClick={open}>
                                                {!props.attributes.img_ID ? (
                                                    __('Upload Image/Video', 'blocks-bakery')
                                                ) : (<img src={props.attributes.img_URL} />

                                                )}
                                            </Button>
                                        )}></MediaUpload>
                                </MediaUploadCheck>
                            )}
                        </div>

                    </PanelBody>
                    <PanelBody title={__('Border', 'blocks-bakery')} initialOpen={false}>
                        <SelectControl
                            label={__('Border Style', 'blocks-bakery')}
                            value={props.attributes.select_border}
                            options={[
                                { value: 'none', label: 'None' },
                                { value: 'solid', label: 'Solid' },
                                { value: 'dotted', label: 'Dotted' },
                                { value: 'dashed', label: 'Dashed' },
                                { value: 'double', label: 'Double' },
                                { value: 'groove', label: 'Groove' },
                                { value: 'inset', label: 'Inset' },
                                { value: 'outset', label: 'Outset' },
                                { value: 'ridge', label: 'Ridge' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ select_border: new_val })
                            }}
                        />
                        <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    label={__('Border Width', 'blocks-bakery')}
                                    min={0}
                                    max={50}
                                    value={props.attributes.border_width}
                                    step={0.1}
                                    initialPosition={1}
                                    onChange={(new_val) => {
                                        props.setAttributes({ border_width: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba", marginTop: "25px"
                            }}
                                onClick={() => {
                                    props.setAttributes({ border_width: 1 })
                                }}> Reset
                            </Button>
                        </div>
                        <div className="range-controler" style={{ display: "flex" }}>
                            <div style={{ marginRight: "10px", width: "100%" }}>
                                <RangeControl
                                    label={__('Border Radius', 'blocks-bakery')}
                                    min={0}
                                    max={50}
                                    value={props.attributes.border_radius}
                                    step={0.1}
                                    initialPosition={10}
                                    onChange={(new_val) => {
                                        props.setAttributes({ border_radius: new_val })
                                    }} />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba", marginTop: "25px"
                            }}
                                onClick={() => {
                                    props.setAttributes({ border_radius: 10 })
                                }}> Reset
                            </Button>
                        </div>

                        <p>Border Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.border_color }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            value={props.attributes.border_color}
                            onChange={(new_val) => {
                                props.setAttributes({ border_color: new_val })
                            }}
                        />

                        <PanelRow>
                            <p>Box Shadow</p>
                            <div>
                                <Button onClick={boxShadowReset} style={{ padding: 0 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={shadow_box} /></span></Button>

                            </div>
                        </PanelRow>
                        <Card id='shadow' style={{ display: 'none' }}>
                            <CardBody>
                                <p>Color<span>
                                    <ColorIndicator
                                        style={{ backgroundColor: props.attributes.shadow_color }} /></span></p>
                                <ColorPalette
                                    colors={color_palette_list}
                                    value={props.attributes.shadow_color}
                                    onChange={(new_val) => {
                                        props.setAttributes({ shadow_color: new_val })
                                    }}
                                />
                                <div className="range-controler" style={{ display: "flex" }}>
                                    <div style={{ marginRight: "10px", width: "100%" }}>
                                        <RangeControl
                                            label={__('Horizontal', 'blocks-bakery')}
                                            min={-100}
                                            max={100}
                                            step={0.1}
                                            value={props.attributes.hori_shadow}
                                            initialPosition={0}
                                            onChange={(new_val) => {
                                                props.setAttributes({ hori_shadow: new_val })
                                            }} />
                                    </div>
                                    <Button style={{
                                        background: 'transparent', border: '1px solid #007cba', fontSize: '11px', height: "31px", color: "#007cba", marginTop: "25px"
                                    }}
                                        onClick={() => {
                                            props.setAttributes({ hori_shadow: 0 })
                                        }}> Reset
                                    </Button>
                                </div>
                                <div className="range-controler" style={{ display: "flex" }}>
                                    <div style={{ marginRight: "10px", width: "100%" }}>
                                        <RangeControl
                                            label={__('Vertical', 'blocks-bakery')}
                                            min={-100}
                                            max={100}
                                            step={0.1}
                                            value={props.attributes.vertical_shadow}
                                            initialPosition={0}
                                            onChange={(new_val) => {
                                                props.setAttributes({ vertical_shadow: new_val })

                                            }} />
                                    </div>
                                    <Button style={{
                                        background: 'transparent', border: '1px solid #007cba', fontSize: '11px', height: "31px", color: "#007cba", marginTop: "25px"
                                    }}
                                        onClick={() => {
                                            props.setAttributes({ vertical_shadow: 0 })
                                        }}> Reset
                                    </Button>
                                </div>
                                <div className="range-controler" style={{ display: "flex" }}>
                                    <div style={{ marginRight: "10px", width: "100%" }}>
                                        <RangeControl
                                            label={__('Blur', 'blocks-bakery')}
                                            min={0}
                                            max={100}
                                            step={0.1}
                                            value={props.attributes.blur_shadow}
                                            initialPosition={0}
                                            onChange={(new_val) => {
                                                props.setAttributes({ blur_shadow: new_val })
                                            }} />
                                    </div>
                                    <Button style={{
                                        background: 'transparent', border: '1px solid #007cba', fontSize: '11px', height: "31px", color: "#007cba", marginTop: "25px"
                                    }}
                                        onClick={() => {
                                            props.setAttributes({ blur_shadow: 0 })
                                        }}> Reset
                                    </Button>
                                </div>
                                <div className="range-controler" style={{ display: "flex" }}>
                                    <div style={{ marginRight: "10px", width: "100%" }}>
                                        <RangeControl
                                            label={__('Spread', 'blocks-bakery')}
                                            min={0}
                                            max={100}
                                            step={0.1}
                                            value={props.attributes.spread_shadow}
                                            initialPosition={0}
                                            onChange={(new_val) => {
                                                props.setAttributes({ spread_shadow: new_val })
                                            }} />
                                    </div>
                                    <Button style={{
                                        background: 'transparent', border: '1px solid #007cba', fontSize: '11px', height: "31px", color: "#007cba", marginTop: "25px"
                                    }}
                                        onClick={() => {
                                            props.setAttributes({ spread_shadow: 0 })
                                        }}> Reset
                                    </Button>
                                </div>
                                <SelectControl
                                    label={__('Position', 'blocks-bakery')}
                                    value={props.attributes.shadow_selector}
                                    options={[
                                        { value: 'inset', label: 'inset' },
                                        { value: '', label: 'outset' },
                                    ]}
                                    onChange={(new_val) => {
                                        props.setAttributes({ shadow_selector: new_val })
                                    }}
                                />
                            </CardBody>
                        </Card>
                    </PanelBody>
                </InspectorControls >
                <BlockControls>
                    <BlockAlignmentToolbar
                        value={props.attributes.block_alignment}
                        onChange={(new_val) => {
                            props.setAttributes({ block_alignment: new_val })
                            if (new_val === "full") {
                                props.setAttributes({ width_content: 'initial' })
                            }
                        }} />
                </BlockControls>
                <div align={props.attributes.block_alignment} className={`gb-section${props.attributes.unique_class_id}`}>
                    <div className='gb-section-wrapper'>
                        <Divtag className="gb-section-inner">
                            <div className="gb-section-inner-overlay">
                                <div className="gb-section-changetag" tagName={props.attributes.heading_tag}>
                                    <InnerBlocks
                                        orientation="horizontal"
                                        template={[
                                            ['core/paragraph']
                                        ]}
                                    />
                                </div>
                            </div>


                        </Divtag>
                    </div>
                </div>
            </React.Fragment>
        ]
    },

    save: (props) => {
        const Divtag = props.attributes.heading_tag;

        return (
            <React.Fragment>
                <style dangerouslySetInnerHTML={{
                    __html: `
                    .gb-section${props.attributes.unique_class_id}{align:${props.attributes.block_alignment}} 
                    .gb-section${props.attributes.unique_class_id} .gb-section-wrapper .gb-section-inner{margin:auto; box-sizing:border-box; border-radius:${props.attributes.border_radius}px; box-shadow:${props.attributes.hori_shadow}px ${props.attributes.vertical_shadow}px ${props.attributes.blur_shadow}px ${props.attributes.spread_shadow}px ${props.attributes.shadow_color} ${props.attributes.shadow_selector}; margin-top:${props.attributes.top_margin}px;margin-bottom: ${props.attributes.bottom_margin}px; margin-left: ${props.attributes.left_margin}px; margin-right: ${props.attributes.right_margin}px; max-width: ${props.attributes.width_content}px; background-size:cover; background-position:center; background-image:url(${props.attributes.img_URL});position:relative; }
                    .gb-section${props.attributes.unique_class_id} .gb-section-wrapper .gb-section-inner .gb-section-inner-overlay{ border-style: ${props.attributes.select_border}; border-width: ${props.attributes.border_width}px; border-color: ${props.attributes.border_color}; padding-top: ${props.attributes.top_padding}px; padding-bottom: ${props.attributes.bottom_padding}px; padding-left: ${props.attributes.left_padding}px; padding-right: ${props.attributes.right_padding}px; border-radius: ${props.attributes.border_radius}px; background: ${props.attributes.gradient_bg}; background-color: ${props.attributes.bg_color + props.attributes.opacity_value}; overflow-wrap:break-word; }
                    .gb-section${props.attributes.unique_class_id} .gb-section-wrapper .gb-section-inner .gb-section-inner-overlay .gb-section-changetag{ max-width: ${props.attributes.maininner_width}px; margin: 'auto';}
                    `
                }}></style>
                <div align={props.attributes.block_alignment} className={`gb-section${props.attributes.unique_class_id}`}>
                    <div className='gb-section-wrapper'>
                        <Divtag
                            className="gb-section-inner">
                            <div className="gb-section-inner-overlay">
                                <div className="gb-section-changetag" tagName={props.attributes.heading_tag}>
                                    <InnerBlocks.Content />
                                </div>
                            </div>
                        </Divtag>
                    </div>
                </div>
            </React.Fragment>
        )
    }
});


function makeUnqiueId() {
            
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < 8; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;


}